document
    .addEventListener("DOMContentLoaded", function () {

        let qflag = false;

        const canvas = document.getElementById("hero-lightpass-sensor");

        if (canvas) {

            const context = canvas.getContext("2d");

            canvas.width = 1920;
            canvas.height = 1080;

            // const currentFrame = index => (`./controller_${ (index +
            // 1).toString().padStart(5, '0')}.webp`); Function to remove versioning from
            // URL
            const stripVersioning = url => url.split('?')[0];
            const getVersionValue = url => url.split('?')[1];
            // Cleaned base path
            const cleanAssetBasePath = stripVersioning(assetBasePath);

            const version_number = getVersionValue(assetBasePath);
            let rocket_base_path = "https://89005a70.delivery.rocketcdn.me/cdn/shop/t/7/assets/sensor_";
            let rocket_base_path_lowq = "https://89005a70.delivery.rocketcdn.me/cdn/shop/t/7/assets/PREFIXPREFIXsensor_";

            //let shopifycdn = "https://www.soildrops.com/cdn/shop/t/7/assets/sensor_";
            //let shopifycdn1 = "https://www.soildrops.com/cdn/shop/t/7/assets/PREFIXPREFIXsensor_";

            let shopifycdn = "https://d2z3gxouiwc498.cloudfront.net/sensor_";
            let shopifycdn1 = "https://d2z3gxouiwc498.cloudfront.net/PREFIXPREFIXsensor_";

            // Construct dynamic URLs
            const currentFrame = index => `${shopifycdn}${ (index + 1)
                .toString()
                .padStart(5, '0')}.webp`;
            const currentFrame_low = index => `${shopifycdn1}${ (index + 1)
                .toString()
                .padStart(5, '0')}.webp`;
            let sensor_images = [];
            let sensor_images_lowq = [];
            let temp_images1 = [];
            let temp_images1lowq = [];

            const frameCount = 390;

            const airpods = {
                frame: 0
            };

            async function loadImages() {
                const totalImages = 390;
                const firstBatchSize = Math.floor(totalImages / 2);
                const secondBatchSize = totalImages - firstBatchSize;
                // First batch: Load every other image (0, 2, 4, ..., 388)
                const firstBatchPromises = [];
                const firstBatchPromises_lowq = [];

                for (let i = 0; i < firstBatchSize; i++) {
                    const img = new Image();
                    img.src = currentFrame_low(i * 2); // Skipping every other image: 0, 2, 4, 6, ...
                    firstBatchPromises_lowq.push(new Promise((resolve) => {
                        img.onload = () => {
                            temp_images1lowq[i * 2] = img;
                            resolve(img); // Resolve when image is loaded
                        };
                    }));

                }

                // Wait for all images in the first batch to load
                await Promise.all(firstBatchPromises_lowq);
                sensor_images_lowq = [...temp_images1lowq]
                console.log('First batch low quality loaded');
                render();

                for (let i = 0; i < firstBatchSize; i++) {
                    const img = new Image();
                    img.src = currentFrame(i * 2); // Skipping every other image: 0, 2, 4, 6, ...
                    firstBatchPromises.push(new Promise((resolve) => {
                        img.onload = () => {
                            temp_images1[i * 2] = img;
                            resolve(img); // Resolve when image is loaded
                        };
                    }));

                }

                // Wait for all images in the first batch to load
                await Promise.all(firstBatchPromises);
                sensor_images = [...temp_images1]
                qflag = true
                console.log('First batch loaded');
                render();
                console.log("render first frame")

                // Second batch: Load the remaining images (1, 3, 5, ..., 389)
                const secondBatchPromises = [];
                for (let i = 0; i < secondBatchSize; i++) {
                    const img = new Image();
                    img.src = currentFrame(i * 2 + 1); // Skipping the first batch images: 1, 3, 5, 7, ...
                    secondBatchPromises.push(new Promise((resolve) => {
                        img.onload = () => {
                            sensor_images[i * 2 + 1] = img; // Store in the array at correct index
                            resolve(img); // Resolve when image is loaded
                        };
                    }));

                }

                // Wait for all images in the second batch to load
                await Promise.all(secondBatchPromises);

                console.log('Second batch loaded');

                console.log('All images loaded');
            }

            loadImages();

            function render() {
                //console.log(airpods.frame)
                const currentImage = qflag
                    ? sensor_images[airpods.frame]
                    : sensor_images_lowq[airpods.frame];

                // Check if the current image is loaded using the 'complete' property
                if (currentImage !== null && currentImage && currentImage.complete) {
                    context.clearRect(0, 0, canvas.width, canvas.height);
                    context.drawImage(currentImage, 0, 0);
                } else {
                    // Optionally, log or show a placeholder if the image isn't loaded yet
                    console.log('Image not yet loaded');
                }
            }

            let mm = gsap.matchMedia();

            mm.add("(min-width: 701px)", () => {

                const timeline_intro = gsap.timeline({
                    scrollTrigger: {
                        trigger: ".bg-waves-sensor",
                        start: "top top",
                        end: "+=600",
                        scrub: 1,
                        //markers:true
                    }
                });
                timeline_intro.fromTo(".intro-heading-div-sensor", {
                    top: "30%"
                }, {
                    top: "-100%"
                }, "<").to(".bg-waves-sensor", {
                    top: "-100%"
                }, "<2%").to(".waves-2-sensor-div", {opacity: 1});

                const timeline0 = gsap.timeline({
                    scrollTrigger: {
                        trigger: ".canvas-container-sensor",
                        start: "top top",
                        end: "+=4400",
                        pin: true,
                        aniticipatePin: 1,
                        scrub: 1,
                        //markers: true
                    }
                })
                timeline0.to(airpods, {
                    frame: frameCount - 1,
                    snap: "frame",
                    ease: "none",
                    onUpdate: render
                });

                const master = gsap.timeline({
                    scrollTrigger: {
                        trigger: ".canvas-container-sensor",
                        start: "top top",
                        end: "+=2400",
                        scrub: 1,
                        //markers: true
                    }
                });

                master.fromTo("#p-1-sensor", {
                    opacity: 0
                }, {
                        opacity: 1,
                        duration: 1
                    })
                    .to("#p-1-sensor", {
                    opacity: 0,
                    duration: 1
                })
                    .fromTo("#p-2-sensor", {
                        opacity: 0
                    }, {
                        opacity: 1,
                        duration: 1
                    })
                    .to("#p-2-sensor", {
                        opacity: 0,
                        duration: 1
                    });

                master.fromTo("#p-3-sensor", {
                    opacity: 0
                }, {
                        opacity: 1,
                        duration: 1
                    })
                    .to("#p-3-sensor", {
                    opacity: 0,
                    duration: 1
                })
                    .fromTo("#p-4-sensor", {
                        opacity: 0
                    }, {
                        opacity: 1,
                        duration: 1
                    });

            })

            mm.add("(max-width: 700px)", () => {

                const timeline_intro = gsap.timeline({
                    scrollTrigger: {
                        trigger: ".bg-waves-sensor",
                        start: "top top",
                        end: "+=600",
                        scrub: 1,
                        //markers:true
                    }
                });
                timeline_intro.fromTo(".intro-heading-div-sensor", {
                    top: "12%"
                }, {
                    top: "-100%"
                }, "<").to(".bg-waves-sensor", {
                    top: "-100%"
                }, "<2%").to(".waves-2-sensor-div", {opacity: 1});

                const timeline0 = gsap.timeline({
                    scrollTrigger: {
                        trigger: ".canvas-container-sensor",
                        start: "top top",
                        end: "+=4400",
                        pin: true,
                        aniticipatePin: 1,
                        scrub: 1,
                        //markers: true
                    }
                })
                timeline0.to(airpods, {
                    frame: frameCount - 1,
                    snap: "frame",
                    ease: "none",
                    onUpdate: render
                });

                const master = gsap.timeline({
                    scrollTrigger: {
                        trigger: ".canvas-container-sensor",
                        start: "top top",
                        end: "+=2400",
                        scrub: 1,
                        //markers: true
                    }
                });

                master.fromTo("#p-1-sensor", {
                    opacity: 0
                }, {
                        opacity: 1,
                        duration: 1
                    })
                    .to("#p-1-sensor", {
                    opacity: 0,
                    duration: 1
                })
                    .fromTo("#p-2-sensor", {
                        opacity: 0
                    }, {
                        opacity: 1,
                        duration: 1
                    })
                    .to("#p-2-sensor", {
                        opacity: 0,
                        duration: 1
                    });

                master.fromTo("#p-3-sensor", {
                    opacity: 0
                }, {
                        opacity: 1,
                        duration: 1
                    })
                    .to("#p-3-sensor", {
                    opacity: 0,
                    duration: 1
                })
                    .fromTo("#p-4-sensor", {
                        opacity: 0
                    }, {
                        opacity: 1,
                        duration: 1
                    });

            })

        }

    });